import { getAllowedOrigins } from './security';

type MessageData = {
  key: string;
  method: 'get' | 'set' | 'remove';
  data?: any;
};

export default class CrossOriginLocalStorage {
  private childWindow: Window;
  private targetOrigin: string;

  constructor(iframe: HTMLIFrameElement, targetOrigin?: string) {
    this.childWindow = iframe.contentWindow as Window;
    // Use specific origin or get from environment
    this.targetOrigin = targetOrigin || getAllowedOrigins()[0] || window.location.origin;
  }

  getData = (key: string): void => {
    const messageData: MessageData = {
      key: key,
      method: "get"
    };
    this.postMessage(messageData);
  };

  setData = (key: string, data: any): void => {
    const messageData: MessageData = {
      key,
      data,
      method: "set"
    };
    this.postMessage(messageData);
  };

  removeData = (key: string): void => {
    const messageData: MessageData = {
      key: key,
      method: "remove"
    };
    this.postMessage(messageData);
  };

  postMessage = (messageData: MessageData): void => {
    // Use specific origin instead of wildcard for security
    this.childWindow.postMessage(JSON.stringify(messageData), this.targetOrigin);
  };
}
